import type { AcuityScore, PostAcuityScoreResponse, UUID } from "@/core/types";
import { api } from "@/api";

export type PostAcuityScoreVariables = {
  additional_details?: string;
  patientId: UUID;
  reasoning: string;
  score: AcuityScore;
};

export async function postAcuityScore({
  additional_details,
  patientId,
  reasoning,
  score,
}: PostAcuityScoreVariables): Promise<PostAcuityScoreResponse> {
  return api.acuityTyped.post_acuity_score({
    data: { additional_details, reasoning, score },
    params: { showLoader: false },
    patientId,
  });
}
